import React, { useEffect, useState, useRef } from "react";
// import { useContext } from "react";
// import { Context } from "../context";
import PlusIcon from "../assets/plus.png";
import MinusIcon from "../assets/minus.png";
import { useContext } from "react";
import { Context } from "../context";

const Sidebar = ({ flScreen, noicons, setHeadingHght }, props) => {
	const {
		toggleSideBar,
		setToggleSideBar,
		// prevPage
	} = useContext(Context);
	console.log(noicons, "=====================flScreen========================");
	const elementRef = useRef(null);
	const elem = document.documentElement;
	const accObj = {
		acc1: true,
		acc2: true,
		acc3: true,
		acc4: true,
	};
	const [sidebarToggle, setSidebarToggle] = useState(true);
	const [accordion, setAccordion] = useState(accObj);
	// const [fullscreen, setFullscreen] = useState(false);
	// const { fullscreen, setFullscreen } = useContext(Context);
	const handleToggleBody = (id) => {
		let accBoolean = accordion[id];
		setAccordion(accObj);
		setAccordion((prev) => {
			return { ...prev, [id]: !accBoolean };
		});
	};

	const toggleSidebar = ()=>{
		setToggleSideBar(!toggleSideBar)
	}
	useEffect(() => {
		if (noicons) {
			// setFullscreen(false);
			// document.exitFullscreen();
			setToggleSideBar(true);
		} else if (flScreen) {
			// window.scrollTo(0, 0);
			// elem.requestFullscreen();
			setToggleSideBar(false);
			// setFullscreen(true);
		}
	}, []);
	useEffect(() => {
		if(elementRef !== null && setHeadingHght) {
			console.log(elementRef.current.clientHeight, "elementRef.current =====");
			setHeadingHght(elementRef.current.clientHeight + 18);
		}
	}, []);
	// const toggleFullScreen = () => {
	// 	if (fullscreen) {
	// 		document.exitFullscreen();
	// 	} else {
	// 		elem.requestFullscreen();
	// 	}
	// 	setFullscreen(!fullscreen);
	// };
	return (
		<div id="sidebar" className={`sidebar_wrap ${toggleSideBar ? "" : "collapsed"}`}>
			{!noicons && (
				<div className="nav-btn">
					{/* <button id="toggle2" style={{ cursor: "pointer" }} title="Toggle fullscreen" onClick={toggleFullScreen}>
					<i id="icon2" className={`bi ${fullscreen ? "bi-fullscreen-exit" : "bi-arrows-fullscreen"}`}></i>
				</button> */}

					<button id="toggle" onClick={() => setToggleSideBar(!toggleSideBar)} style={{ cursor: "pointer" }} title="Toggle sidebar">
						<i id="icon1" className={`bi ${toggleSideBar ? "bi-arrow-bar-left" : "bi-list"}`}></i>
					</button>
				</div>
			)}

			<div className="content">
				<div className="heading">
					<h2 ref={elementRef}>Supplier Shield <span className="dash_unnderscore"></span> Supplier Onboarding: <br className="custom-break"/>bank account and address verification</h2>
					<p>
						To reduce the risk of fraud and ensure the timely and accurate payment of invoices, you are required to verify your bank account and proof of address.
					</p>
					<p>
						CBRE partners with{" "}
						<a href="https://diro.io" target="_blank">
							DIRO
						</a>{" "}
						for this process, the leading provider of bank and address verification solutions trusted by F500 and Tier 1 global banks.
					</p>
					<p>
						Please review CBRE's help guides at: <a href="https://www.cbre.com/about-us/supply-chain/suppliers-supply-chain-technologies-and-registration#mysupplier" target="_blank">Suppliers Supply Chain Technologies and Registration | CBRE</a> for further information.
					</p>
				</div>
				<div className="faq">
					<h2>Frequently asked questions</h2>

					<div className="accordion accordion-flush" id="accordionFlushExample">
						<div className="accordion-item">
							<h2 className="accordion-header" id="flush-headingOne">
								<button className={`accordion-button ${accordion.acc1 && "collapsed"}`} type="button" onClick={() => handleToggleBody("acc1")}>
									{accordion.acc1 ? (
										<img className="plus-minus" src={PlusIcon} alt="more" />
									) : (
										<img className="plus-minus" src={MinusIcon} alt="less" />
									)}
									What information will be shared?
								</button>
							</h2>
							<div id="flush-collapseOne" className={`accordion-collapse${accordion.acc1 ? " collapse-box" : ""}`}>
								<div className="accordion-body">
									<ul>
										<li>
											Your bank statement will not be shared with CBRE. Only selected fields as highlighted inside each session will be shared. All
											other data will be purged.
										</li>
										<li>
											Your utility bill will not be shared with CBRE. Only selected fields as highlighted inside each session will be shared. All
											other data will be purged.
										</li>
										<li>
											Any sensitive information such as balance, transactional data, or usage, from your bank statement or utility bill will never be
											shared with CBRE.
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="accordion-item">
							<h2 className="accordion-header" id="flush-headingFour">
								<button className={`accordion-button ${accordion.acc2 && "collapsed"}`} type="button" onClick={() => handleToggleBody("acc2")}>
									{accordion.acc2 ? (
										<img className="plus-minus" src={PlusIcon} alt="more" />
									) : (
										<img className="plus-minus" src={MinusIcon} alt="less" />
									)}
									How does my password remain private?
								</button>
							</h2>
							<div id="flush-collapseFour" className={`accordion-collapse${accordion.acc2 ? " collapse-box" : ""}`}>
								<div className="accordion-body">
									<ul>
										<li>
											The entire verification session provides an end-to-end encryption and remains private. In other words, you will not share your
											password or login credentials with DIRO or CBRE.
										</li>
										<li>Most banks use one time passwords (OTP) with multi-layer security.</li>
										<li>
											Most banks use two-factor authentication (2FA) or multi-factor authentication (MFA). The second factor is sometimes offline, or
											on a separate device, such as a smartphone for high security and to eliminate fraud.
										</li>
										<li>
											Since you will not do a transaction, only verify bank account ownership and proof of address, your transaction password will
											never be asked for in the verification session.
										</li>
										<li>
											Visit DIRO to learn more about{" "}
											<a href="https://diro.io/user-privacy/" target="blank" rel="noopener">
												user privacy
											</a>
											.
										</li>
									</ul>
								</div>
							</div>
						</div>

						<div className="accordion-item">
							<h2 className="accordion-header" id="flush-headingThree">
								<button className={`accordion-button ${accordion.acc3 && "collapsed"}`} type="button" onClick={() => handleToggleBody("acc3")}>
									{accordion.acc3 ? (
										<img className="plus-minus" src={PlusIcon} alt="more" />
									) : (
										<img className="plus-minus" src={MinusIcon} alt="less" />
									)}
									Why should I trust DIRO?
								</button>
							</h2>
							<div id="flush-collapseThree" className={`accordion-collapse${accordion.acc3 ? " collapse-box" : ""}`}>
								<div className="accordion-body">
									<ul>
										<li>
											DIRO is trusted by F500 and Tier 1 global banks in consumer and enterprise verifications across 195 countries. Its solution is
											used to verify bank account ownership, proof of address, and other documents to eliminate fraud, email spoofing, and
											impersonation issues.
										</li>
										<li>
											Visit DIRO to learn more about{" "}
											<a href="https://diro.io/use-cases/vendor-onboarding-kyb/" target="blank" rel="noopener">
												vendor onboarding
											</a>
											.
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="accordion-item">
							<h2 className="accordion-header" id="flush-headingTwo">
								<button className={`accordion-button ${accordion.acc4 && "collapsed"}`} type="button" onClick={() => handleToggleBody("acc4")}>
									{accordion.acc4 ? (
										<img className="plus-minus" src={PlusIcon} alt="more" />
									) : (
										<img className="plus-minus" src={MinusIcon} alt="less" />
									)}
									How DIRO creates a new global standard?
								</button>
							</h2>
							<div id="flush-collapseTwo" className={`accordion-collapse${accordion.acc4 ? " collapse-box" : ""}`}>
								<div className="accordion-body">
									<ul>
										<li>DIRO's solution eliminates the possibility of document fraud, email spoofing, and impersonation issues.</li>
										<li>
											DIRO's ephemeral architecture of each session does not permit, or make possible, any storage of passwords or other login
											credentials. This makes the solution particularly applicable to bank account verification and proof of address in consumer and
											enterprise onboarding to eliminate fraud.
										</li>
										<li>
											DIRO's verification of bank statements and utility bills provides verification of selected source data directly from the bank or
											utility company without the possibility of tampering.
										</li>
										<li>
											KYB (Know Your Business) is mostly a manual process with uploads of simple PDFs which is open to tampering, fake, and stolen
											data. This can lead to fraud and money laundering. DIRO is solving this problem by creating a new global standard for document
											verification in KYB and vendor onboarding.
										</li>
										<li>
											DIRO participated in the UK's{" "}
											<a href="https://www.fca.org.uk/firms/innovation/regulatory-sandbox/accepted-firms" target="_blank">
												FCA (Financial Conduct Authority) sandbox for KYC
											</a>{" "}
											in 2019 (cohort 5) with its bank account verification and proof of address solution.
										</li>
										<li>
											In addition to the UK's FCA, DIRO is in conversation with a number of regulators including FATF, FinCEN, Malta Gaming Authority,
											Central Bank of India, Central Bank of Bahrain, Central Bank of Malaysia, etc. The reason for these conversations is to educate
											and help regulators to strengthen KYC, KYB, and AML requirements based on advancing technology.
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<p>
					Learn more about DIRO's{" "}
					<a href="https://diro.io/products/bank-account-verification/" target="_blank">
						bank account
					</a>{" "}
					and{" "}
					<a href="https://diro.io/products/utility-bill-verification/" target="_blank">
						address verification
					</a>{" "}
					solutions.
				</p>
				<p>
					<a href="https://diro.io/term-condition/" target="_blank">
						Terms of Use.
					</a>{" "}
					<a href="https://diro.io/privacy-policy/" target="_blank">
						Privacy Policy.
					</a>
				</p>
			</div>
		</div>
	);
};

export default Sidebar;

